import { Drawer } from 'antd'
import { observer } from 'mobx-react-lite'

import { HeaderPage } from '@/Core/UI/HeaderPage'
import { List } from '@/Core/UI/List'
import { Filter } from '@/Core/UI/CrudResource/Components/Filter'
import { StatusFilterBar, statusSourceFor } from '@/Ship/Components/Filters/StatusFilterBar'

import './CrudResourceTemplate.css'
import './Table.css'

export const CrudResourceTemplate = ({ crudContext }) => {
    // Рядок статусів над таблицею з'являється сам — на кожному реєстрі, у
    // ресурсу якого є поле `status` з варіантами або з довідником статусів.
    // Де він зайвий (вкладки карток, статус зафіксований сторінкою),
    // `statusSourceFor` дає `null`
    const statusSource = statusSourceFor(crudContext)

    // Вкладка картки тримає стан панелі фільтрів сама — див. `LocalFilterPanel`
    const localPanel = crudContext.storages?.filterPanel
    const isFilterOpen = () => (localPanel ? localPanel.isOpen : crudContext.isFilterOpen)

    const LayoutObserver = observer(({ children }) => {
        const isGap = crudContext.isFilter && isFilterOpen()

        return <div className={`wl-content-wrapper ${isGap ? 'gap' : 'no-gap'}`}>{children}</div>
    })

    /**
     * Хрестик ядрової панелі закриває її через `setIsFilterOpen(false)`, тобто
     * в усіх реєстрах, а панель вкладки лишав би відкритою. Тому у вкладці клік
     * по ньому перехоплюємо ще на спуску, до ядрового обробника
     */
    const closeLocally = (event) => {
        if (!(event.target instanceof Element) || !event.target.closest('.ant-card-extra')) return

        event.stopPropagation()
        localPanel.close()
    }

    const FilterObserver = observer(({ children }) => {
        const isVisible = crudContext.isFilter && isFilterOpen()

        return (
            <div
                className={`filter-panel ${isVisible ? 'visible' : 'hidden'}`}
                {...(localPanel ? { onClickCapture: closeLocally } : {})}
            >
                {children}
            </div>
        )
    })

    return (
        <div
            style={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {crudContext.resource?.places?.top && <div className="place-top">{crudContext.resource.places.top}</div>}
            <LayoutObserver>
                <FilterObserver>
                    <Filter />
                </FilterObserver>

                <div className="content-area">
                    <HeaderPage headerPageContext={crudContext.headerPageContext} />

                    {statusSource ? <StatusFilterBar crudContext={crudContext} source={statusSource} /> : null}

                    <div style={{ marginTop: statusSource ? '16px' : '25px' }}>
                        <List listContext={crudContext.listContext} />
                    </div>
                </div>
            </LayoutObserver>
        </div>
    )
}
